var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttendanceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 3.75V2.5H17.5V1.25H12.5V2.5H11.25V3.75H10V7.5H11.25V8.75H18.75V7.5H20V3.75H18.75ZM13.75 7.5V6.25H12.5V3.75H13.75V2.5H16.25V3.75H17.5V6.25H16.25V7.5H13.75Z",
    fill: "#FFFBF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0039 27.498V6.24805H23.7539V4.99805H21.2539V8.74805H20.0039V9.99805H10.0039V8.74805H8.75391V4.99805H6.25391V6.24805H5.00391V27.498H6.25391V28.748H23.7539V27.498H25.0039ZM20.2075 14.2686V14.7895H20.7284V25.2061H20.2075V25.727H9.79085V25.2061H9.27002V14.7895H9.79085V14.2686H20.2075ZM11.8742 19.477H11.3534V19.9978H11.8742V20.5186H12.395V21.0395H12.9159V21.5603H13.4367V22.0811H13.9575V22.602H14.9992V22.0811H15.52V21.5603H16.0409V21.0395H16.5617V20.5186H17.0825V19.9978H17.6034V19.477H18.1242V18.9561H18.645V18.4353H18.1242V17.9145H17.6034V17.3936H17.0825V17.9145H16.5617V18.4353H16.0409V18.9561H15.52V19.477H14.9992V19.9978H13.9575V19.477H13.4367V18.9561H12.9159V18.4353H12.395V18.9561H11.8742V19.477Z",
    fill: "#FFFBF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendanceIcon);
export default __webpack_public_path__ + "static/media/attendance_icon.f2b565f6d5e9b5b7fab0f122e3806958.svg";
export { ForwardRef as ReactComponent };